/* eslint-disable func-names */
/* global addeventatc */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Icon } from "@qgiv/core-react";
import "./AddToCalendar.scss";
import Button from "../Button";

const AddToCalendar = ({
    additionalText = "",
    btnStyle = "primary",
    buttonLabel = "",
    description = "",
    disabled = false,
    endDate = "",
    formattedAddress = "",
    heading = "",
    location = "",
    startDate = "",
    timezone = "America/New_York",
    title = "",
}) => {
    // In order for us to leave the page and use this button when returning
    // we must refresh the js on load
    setTimeout(() => {
        addeventatc.refresh();
        // This allows us to override third party styling
        window.addeventasync = function () {
            addeventatc.settings({
                css: false,
            });
        };
    }, 200);

    return (
        <div className="widget-calendar grid">
            <div className="col col--12">
                <div className="-callout -padding--30">
                    {/* eslint-disable-next-line tailwindcss/classnames-order */}
                    <div className="grid grid--justify-content-center">
                        {heading && (
                            <div className="col col--12 -padding-top--0 -text--center">
                                <h2>{heading}</h2>
                            </div>
                        )}

                        {additionalText && (
                            <div className="col col--12 -padding-top--5 -margin-bottom--15 -text--center">
                                <p>{additionalText}</p>
                            </div>
                        )}
                        <div
                            style={{ maxWidth: "330px" }}
                            className="col col--12 col--sm-6 col--no-top-gutter -text--center"
                        >
                            {/* eslint-disable-next-line tailwindcss/classnames-order */}
                            <div className="grid grid--tight-gutters grid--justify-content-center">
                                <Button
                                    btnStyle={btnStyle}
                                    classes={cx(
                                        `addeventatc`,
                                        `addeventatc__btn addeventatc__btn--${btnStyle}`,
                                    )}
                                    aria-label={buttonLabel}
                                    // This allows us to override third party styling
                                    data-styling="none"
                                    disabled={disabled}
                                >
                                    <span
                                        className={cx(
                                            "addeventatc__label -type--large -font-family--font-theme",
                                            btnStyle === "secondary" &&
                                                "-color--theme-primary",
                                            btnStyle === "primary" &&
                                                "-color--system-pale",
                                        )}
                                    >
                                        <Icon
                                            className="-margin-right--10 -type--xxlarge"
                                            glyph="calendar-alt-regular"
                                            type="FontAwesome"
                                        />
                                        {buttonLabel}
                                    </span>

                                    <span className="start">{startDate}</span>
                                    <span className="end">{endDate}</span>
                                    <span className="timezone">{timezone}</span>
                                    <span className="title">{title}</span>
                                    {description && (
                                        <span className="description">
                                            {description}
                                        </span>
                                    )}
                                    {(location || formattedAddress) && (
                                        <span className="location">
                                            {`${location} ${formattedAddress}`}
                                        </span>
                                    )}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AddToCalendar.propTypes = {
    heading: PropTypes.string.isRequired,
    additionalText: PropTypes.string,
    buttonLabel: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    timezone: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    location: PropTypes.string,
    btnStyle: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    formattedAddress: PropTypes.string,
};

export default AddToCalendar;
